module.exports = __webpack_public_path__ + "img/3_161.c5bd2974.png";